import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import userStore from '@src/store/user';
import globalStore from '@/store/global';
import client from '@/store/client';
import appLogger from '@public/log/monitor';

import { Flex } from '@/ui';
import Avatar from '@/components/avatar';
import MenuList from './menu-list';

const login = ({className="", avatarClassName="", popClassName="", loginClassName=""}) => {
  const [showPop, setShowPop] = useState(false);

  const checkClosest = evt => {
    if (!evt.target?.closest('.header_setting')) {
      setShowPop(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', checkClosest, false);

    return () => {
      document.removeEventListener('click', checkClosest, false);
    };
  }, []);

  if(client.isLLQ){
    return null;
  }

  return (
    <div className={`header_setting flex-shrink-0 relative z-10 group cursor-pointer ${className}`}>
      {userStore.isUser ? (
        <>
          <Avatar
            className={`relative z-1 ${avatarClassName}`}
            onClick={() => {
              setShowPop(true);
            }}
          />
          <div
            className={[
              showPop ? 'block' : 'hidden',
              'absolute right-0 top-44px',
              ' w-240px pt-20px pb-16px rounded-8px',
              popClassName
            ]}
            style={{
              background: globalStore.isDark ? "var(--bg-dropdown)" : '#fff',
              boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.1)',
            }}
          >
            <div className="flex items-center px-20px">
              <Avatar className="!size-40px" />
              <span className="text-16px font-bold text-primary-opacity ml-16px py-4px truncate">
                {userStore.showNickname}
              </span>
            </div>
            <MenuList />
          </div>
        </>
      ) : (
        <Flex
          center
          className={[
            'w-74px h-32px text-14px',
            'group cursor-pointer mr-20px',
            'rounded-full border-1px border-[rgba(0,0,0,0.1)]',
            'bg-button-bg-normal hover:bg-button-bg-hover hover:border-none hover:font-bold',
            loginClassName
          ]}
          onClick={() => {
            appLogger.log({
              key: 'aibot_home',
              action: 'click',
              arrt: 'login',
            });
            userStore.gotoLogin();
          }}
        >
          登录
        </Flex>
      )}
    </div>
  );
};

export default observer(login); 